<template>
  <v-textarea
    class="mt-2 mb-4 niko-textarea"
    :value="
      value !== null && value !== undefined && value.length > maxLength
        ? value.slice(0, maxLength)
        : value
    "
    filled
    rounded
    outlined
    row-height="1"
    hide-details
    auto-grow
    oninput="if (value.length > maxLength) value = value.slice(0, maxLength);"
    :maxLength="maxLength"
    :rows="rows"
    :disabled="disabled"
    :aria-readonly="readonly"
    :placeholder="placeholder"
    @change="(value) => valueChanged(value)"
  ></v-textarea>
</template>
<script>
export default {
  name: "niko-textarea",
  props: {
    value: String,
    placeholder: String,
    rows: Number,
    disabled: Boolean,
    readonly: Boolean,
    maxLength: {
      type: Number,
      default: 1000,
    },
  },
  methods: {
    valueChanged(value) {
      this.$emit("onChange", value);
    },
  },
};
</script>
<style lang="scss">
.niko-textarea {
  textarea {
    margin: 0 !important;
  }

  textarea::placeholder {
    padding-top: 2px !important;
  }
}
</style>
